import { useContext } from 'react';

import { ApiContext } from '../api-context';

// ----------------------------------------------------------------------

export const useApiContext = () => {
  const context = useContext(ApiContext);

  if (!context) throw new Error('useApiContext context must be use inside ApiProvider');

  return context;
};
